import Done from '@/pages/Done';

export const StarterDone = () => <Done />;
